@if (label) {
    <label [for]="for" class="form-label text-nowrap d-block">
        {{ label }}
        @if (required) {
            <span class="text-danger">*</span>
        }
    </label>
}
